import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Collapsible PDP details — description, shipping, care/trust bullets.
 */
export default function PdpDetailAccordions({
  aboutHeading = 'About this piece',
  description = '',
  bullets = [],
  shippingHeading = 'Shipping & delivery',
  shippingNote = 'Ships across India',
  returnsHeading = 'Returns & care',
  returnsNote = 'See our return policy for eligible items.',
}) {
  const hasDescription = Boolean(String(description || '').trim());
  const hasBullets = bullets.some((b) => String(b?.text || '').trim());

  return (
    <div className="pdp-accordions">
      {hasDescription ? (
        <details className="pdp-accordion" open>
          <summary className="pdp-accordion__summary">{aboutHeading}</summary>
          <div className="pdp-accordion__body">
            <p className="mb-0">{description}</p>
          </div>
        </details>
      ) : null}

      <details className="pdp-accordion">
        <summary className="pdp-accordion__summary">{shippingHeading}</summary>
        <div className="pdp-accordion__body">
          <p className="pdp-accordion__lead mb-2">{shippingNote}</p>
          <p className="pdp-accordion__links mb-0">
            <Link to="/policies/shipping">Shipping policy</Link>
            <span aria-hidden="true"> · </span>
            <Link to="/contact">Ask about delivery</Link>
          </p>
        </div>
      </details>

      <details className="pdp-accordion">
        <summary className="pdp-accordion__summary">{returnsHeading}</summary>
        <div className="pdp-accordion__body">
          <p className="pdp-accordion__lead mb-2">{returnsNote}</p>
          {hasBullets ? (
            <ul className="pdp-accordion__list mb-0">
              {bullets.map((bullet, i) => (
                <li key={`pdp-acc-bullet-${i}`}>
                  {bullet.text}
                  {bullet.link_label && bullet.link_href ? (
                    <>
                      {' '}
                      <Link to={bullet.link_href}>{bullet.link_label}</Link>
                    </>
                  ) : null}
                </li>
              ))}
            </ul>
          ) : (
            <p className="pdp-accordion__links mb-0">
              <Link to="/policies/returns">Return policy</Link>
            </p>
          )}
        </div>
      </details>
    </div>
  );
}
